<template>
  <template v-if="!loaded">
    <esp-realization/>
    <orders-week/>
    <div class="row">
      <div class="col-xxl-9">
        <tickets-realization/>
      </div>
      <div class="col-xxl-3">
        <tickets-realization-pie/>
      </div>
    </div>
  </template>
  <loader v-else :height="100"/>
</template>

<script>
  import EspRealization from '@/components/EspRealization'
  import TicketsRealization from '@/components/TicketsRealization'
  import TicketsRealizationPie from '@/components/TicketsRealizationPie'
  import Loader from '@/components/Loader'
  import OrdersWeek from '@/components/OrdersWeek'

  export default {
    name: 'Index',
    components: {OrdersWeek, EspRealization, Loader, TicketsRealization, TicketsRealizationPie},
    data() {
      return {
        loaded: false,
      }
    },
  }
</script>
<style scoped>

</style>